// extracted by mini-css-extract-plugin
export var boxItems = "_64-1";
export var boxItemsLg = "_64-2";
export var button = "_64-7";
export var buttonLg = "_64-8";
export var filterGroupBox = "_64-0";
export var icon = "_64-3";
export var iconSecondary = "_64-6";
export var iconWrapper = "_64-4";
export var iconWrapperLg = "_64-5";